import { createSlice } from '@reduxjs/toolkit';
import { ConversationStore } from '../types';
import { commentSlice } from './comment.slice';
import { conversationSlice } from './conversation.slice';

const INITIAL_STATE: ConversationStore = {};

export const slice = createSlice({
  name: '@@conversation',
  initialState: INITIAL_STATE,
  reducers: {
    ...conversationSlice,
    ...commentSlice,
  },
});

export const {
  fetchStart,
  fetchSuccess,
  fetchError,
  deleteComment,
  updateComment,
  createComment,
} = slice.actions;
